import React, { useEffect, useRef, useState } from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";
// Pages / Components
import Home from "./components/Home";
import HomeLoan from "./components/HomeLoan";
import PersonalLoan from "./components/PersonalLoan";
import LoanAgainstProperty from "./components/LoanAgainstProperty";
import BusinessLoan from "./components/BusinessLoan";
import CarLoan from "./components/CarLoan";
import EducationLoan from "./components/EducationLoan";
import InstaLoan from "./components/InstaLoan";
import Career from "./components/Career";
import JobSeeker from "./components/JobSeeker";
import Help from "./components/Help";
import About from "./components/About";
import Cibil from "./components/Cibil";
import Coming from "./components/Coming";
import YearsExperience from "./components/YearsExperience";
import Freelancer from "./components/Freelancer";

import Layout from "./layout";
import AppToast from "./common/toaster";
import BankingPartner from "./components/BankingPartner";
import SatisfiedCustomers from "./components/SatisfiedCustomer";
import ContactUs from "./components/ContactUs";
import TeamMemberHierarchy from "./components/TeamMemberHierarchy";
import { GeneralSettingProvider } from "./context/GeneralSettingContext";
import ServicesPages from "./components/ServicesPages";
import LoanApplyForm from "./common/loan-apply-form";
import CalculatorPage from "./components/CalculatorPage";
import InstantServicesPage from "./components/InstantServices";
import InstantServiceDetail from "./components/InstantServiceDetail";
import EmailVerification from "./components/EmailVerification";
import EmailVerificationRedirect from "./components/EmailVerificationRedirect";
import ItProduct from "./components/ItProduct";
import LifeInsurance from "./components/Insurance/LifeInsurance";
import HealthInsurance from "./components/Insurance/HealthInsurance";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TwoWheeler from "./components/TwoWheeler";
import CarInsurance from "./components/Insurance/CarInsurance";
import HomeInsurance from "./components/Insurance/HomeInsurance";
import TravelInsurance from "./components/Insurance/TravelInsurance";
import BusinessInsurance from "./components/Insurance/BusinessInsurance";
import RealState from "./components/RealState";
import ResumeBuilder from "./components/Builder/ResumeBuilder";
import ScrollTop from "./components/ScrollTop";

// --- SCROLL TO TOP COMPONENT USING LENIS ---
const ScrollToTopButton = () => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();

  const isHome = location.pathname === "/";
  useEffect(() => {
    const toggleVisible = () => {
      const scrolled = window.scrollY;
      setVisible(scrolled > 400);
    };
    window.addEventListener("scroll", toggleVisible);
    return () => window.removeEventListener("scroll", toggleVisible);
  }, []);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      className={`scroll-btn ${visible ? "show" : ""} ${isHome ? "at-home" : ""}`}
      onClick={handleScrollToTop}
      aria-label="Scroll to top"
    >
      <div className="scroll-btn-content">
        <span className="arrow">↑</span>
        <span className="text">TOP</span>
      </div>
    </button>
  );
};

function App() {
  // const [lenisInstance, setLenisInstance] = useState(null);

  // useEffect(() => {
  //   setTimeout(() => {
  //     const lenis = new Lenis({
  //       duration: 1.2,
  //       easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  //       smoothWheel: true,
  //       orientation: "vertical",
  //       gestureOrientation: "vertical",
  //       smoothTouch: false,
  //     });

  //     setLenisInstance(lenis);

  //     function raf(time) {
  //       lenis.raf(time);
  //       requestAnimationFrame(raf);
  //     }

  //     requestAnimationFrame(raf);

  //     return () => {
  //       lenis.destroy();
  //     };
  //   }, 3000);
  // }, []);

  return (
    <Router>
      <GeneralSettingProvider>
        <Layout>
          <AppToast />
          <div className="App">
            <ScrollTop />
            <Routes>
              {/* Home is the root route */}
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Navigate to="/" replace />} />

              {/* Loan Pages */}
              <Route path="/home-loan" element={<HomeLoan />} />
              <Route path="/personal-loan" element={<PersonalLoan />} />
              <Route
                path="/loan-against-property"
                element={<LoanAgainstProperty />}
              />
              <Route path="/business-loan" element={<BusinessLoan />} />
              <Route path="/car-loan" element={<CarLoan />} />
              <Route path="/education-loan" element={<EducationLoan />} />
              <Route path="/two-wheeler-loan" element={<TwoWheeler />} />
              <Route path="/insta-loan" element={<InstaLoan />} />
              <Route path="/life-insurance" element={<LifeInsurance />} />
              <Route path="/health-insurance" element={<HealthInsurance />} />
              <Route path="/car-insurance" element={<CarInsurance />} />
              <Route path="/home-insurance" element={<HomeInsurance />} />
              <Route path="/Travel-Insurance" element={<TravelInsurance />} />
              <Route
                path="/business-Insurance"
                element={<BusinessInsurance />}
              />
              <Route path="/real-estate" element={<RealState />} />

              {/* Other Pages */}
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/careers" element={<Career />} />
              <Route path="/job-seeker" element={<JobSeeker />} />
              <Route path="/help" element={<Help />} />
              <Route path="/about" element={<About />} />
              <Route path="/cibil" element={<Cibil />} />
              <Route path="/year-experience" element={<YearsExperience />} />
              <Route path="/resume" element={<ResumeBuilder />} />

              <Route
                path="/satisfied-customers"
                element={<SatisfiedCustomers />}
              />
              <Route path="/banking-partners" element={<BankingPartner />} />
              <Route path="/freelancers" element={<Freelancer />} />

              <Route
                path="/team-members/view/:teamMemberId"
                element={<TeamMemberHierarchy />}
              />
              <Route path="/apply/:slug" element={<LoanApplyForm />} />
              <Route path="/it-products" element={<ItProduct />} />
              <Route path="/services/:slug" element={<ServicesPages />} />
              <Route path="/emi-calculator" element={<CalculatorPage />} />
              <Route
                path="/privacy-security-policy"
                element={<PrivacyPolicy />}
              />
              <Route
                path="/instant-services/:slug"
                element={<InstantServicesPage />}
              />
              <Route
                path="/instant-services-detail/:id"
                element={<InstantServiceDetail />}
              />
              <Route
                path="/verify-email/:hash"
                element={<EmailVerification />}
              />
              <Route
                path="/api/v1/verify-email/:hash"
                element={<EmailVerification />}
              />
              <Route
                path="/api/v1/leads"
                element={<EmailVerificationRedirect />}
              />
              <Route path="*" element={<Coming />} />
            </Routes>

            <ToastContainer position="top-right" autoClose={3000} />

            {/* Render Button and pass the Lenis instance */}
            <ScrollToTopButton />
          </div>
        </Layout>
      </GeneralSettingProvider>
    </Router>
  );
}

export default App;
